import React from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'
import { Textarea } from '~/lib/ui/textarea'

const VisionStatementPageFive = () => {
  const { getResponse, exerciseIndex, handleChange, formattedExerciseName } =
    useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const pageFiveTranslations = t('pages.4')

  const paragraphs = pageFiveTranslations.paragraphs
  const textboxLabels = pageFiveTranslations.questions

  return (
    <div>
      {paragraphs.map((paragraph, index) => (
        <p key={index}>{paragraph}</p>
      ))}
      <div className="mb-4 flex flex-col gap-8">
        {textboxLabels.map((label, index) => (
          <label key={index}>
            {label.question}
            <Textarea
              className="mt-6 min-h-[125px] w-full rounded-[20px] font-roboto text-base font-normal"
              value={getResponse(exerciseIndex, label.slug)}
              onChange={(value) =>
                handleChange(exerciseIndex, label.slug, value)
              }
            />
          </label>
        ))}
      </div>
    </div>
  )
}

export default VisionStatementPageFive
